import MockData from "../../assets/mocks/plans-user.json";

import type { PlanName } from "@/types/plans";
import type { PlanUser } from "./get-user-plan";

export let mockUserPlan: PlanUser = {
  ...MockData,
  name: MockData.name as PlanName,
};

export function updateMockUserPlan(plan: PlanName) {
  mockUserPlan = {
    ...mockUserPlan,
    name: plan,
    created_at: new Date().toISOString(),
  };
}
